import axios from "axios"

function handleEndpoint() {
  const isActive = process.env.REACT_APP_ENABLE_LOGGING === "TRUE" ? true : false

  if (!isActive) {
    return null
  } else {
    return process.env.REACT_APP_CLOUD_FUNCTIONS
  }
}

const endpoint = handleEndpoint()

export default function useLogs() {
  if (endpoint === null) {
    return [false, null]
  }
  return [true, writeLog]
}

async function writeLog(args) {
  const { type, path, message, stack = "" } = args
  const body = {
    type,
    log: {
      source: "client",
      path,
      message,
      stack,
    },
  }
  try {
    return await axios.post(`${endpoint}/logger`, body)
  } catch (error) {
    throw error
  }
}
